import { render, staticRenderFns } from "./regionIntroDialog.vue?vue&type=template&id=2fd9c176&scoped=true"
import script from "./regionIntroDialog.vue?vue&type=script&lang=js"
export * from "./regionIntroDialog.vue?vue&type=script&lang=js"
import style0 from "./regionIntroDialog.vue?vue&type=style&index=0&id=2fd9c176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9c176",
  null
  
)

export default component.exports